import React from "react";

const GroupSexRoomRobertonOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="652.796"
      height="633.619"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 652.796 633.619"
      xmlSpace="preserve"
      className='clickable object-glow'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-1972.87 -1113.913)"
      >
        <path
          strokeWidth="5"
          d="M2128 1156.4c-2.8 1.87-4.43 4.67-4.9 8.4-.47 3.73 2.8 17.97 9.8 42.7 7 24.73 11.2 42.93 12.6 54.6 1.4 11.67 3.5 22.4 6.3 32.2 2.8 9.8 4.2 19.13 4.2 28 0 8.87.7 16.33 2.1 22.4 1.4 6.07 1.87 15.4 1.4 28-.47 12.6-2.1 22.63-4.9 30.1-2.8 7.47-3.5 14-2.1 19.6 1.4 5.6 4.43 8.63 9.1 9.1 4.67.47 16.57-2.1 35.7-7.7 19.13-5.6 33.37-9.1 42.7-10.5 9.33-1.4 22.17-2.57 38.5-3.5 16.33-.93 37.1-1.17 62.3-.7 25.2.47 41.07 0 47.6-1.4 6.53-1.4 9.57-4.43 9.1-9.1-.47-4.67-2.57-8.63-6.3-11.9-3.73-3.27-9.1-19.13-16.1-47.6-7-28.47-11.43-44.1-13.3-46.9-1.87-2.8-2.57-7.47-2.1-14 .47-6.53-.47-13.07-2.8-19.6-2.33-6.53-3.5-18.67-3.5-36.4 0-17.73.93-28.7 2.8-32.9 1.87-4.2 3.03-8.87 3.5-14 .47-5.13-.47-9.33-2.8-12.6-2.33-3.27-6.3-4.9-11.9-4.9-5.6 0-16.57 1.87-32.9 5.6a568.658 568.658 0 00-48.3 13.3c-15.87 5.13-28.47 5.6-37.8 1.4-9.33-4.2-25.67-9.33-49-15.4s-36.63-9.1-39.9-9.1c-3.27 0-6.3.93-9.1 2.8z"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2125.58 1188.31c.2-.39-3.49 2.13-4.56 2.73-3.2 1.83-6.33 3.91-9.68 5.59-10.43 5.21-21.44 10.26-31.68 15.38"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2184.37 1162.27l2.45-19.32s.74-9.14 7.32-14.52c6.57-5.38 18.98-6.99 18.98-6.99s47.66-5.37 115.62-5.01c67.96.37 160.86 5.2 160.86 5.2s28.35.98 33.6 19.01c5.26 18.02 9.4 30.02 8.41 58.38-.99 28.36-9.54 58.65-9.54 58.65"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2622.41 1229.06s.67 24.85-.73 43.34c-1.41 18.49-5.5 36.5-5.5 36.5"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2018.6 1461.4l374.15 20.48"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2019.18 1459.57s29.1-18.55 61.85-30.42c32.75-11.88 69.14-17.1 69.14-17.1"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2393.17 1729.85l.87 10.29s.22 2.94 1.58 4.13c1.35 1.19 3.85.63 3.85.63"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2031.15 1689.9l.77 17.83s1.09 3.6 4.41 5.42c3.33 1.83 8.89 1.89 8.89 1.89l16.27-.7s4 .64 6.04-1.9c2.03-2.55 2.09-8.28 2.09-8.28l3.24-9.9"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M1975.37 1635.79l13.57 37.72s2.88 9.6 9.54 11.72c6.65 2.12 20.48 1.17 20.48 1.17s145.51 9.46 235.96 18.83c90.46 9.38 125.86 18.67 125.86 18.67s6.58 1.23 11.06 3.44c4.49 2.21 8.55 2.81 8.55 2.81"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="5"
          d="M2534.27 1185.07s52.6 9.84 71.45 14.53c18.84 4.68 18.24 15.86 16.79 25.99-2.81 19.74-30.72 52.51-30.72 52.51"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M1977.19 1384.54l32.39 74.2s.77 3.14 2.42 3.9c1.66.77 4.2-.84 4.2-.84s.47-1.83-.12-3.71-3.13-6.08-3.13-6.08l-31.88-72"
          opacity="1"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2011.86 1464.54s-2.36 6.42.14 20.47c2.51 14.05 4.03 17.94 9.88 35.73 5.84 17.79 12.92 30.93 12.92 30.93l13.51 22.07-1.57 15.4-1.61 23.19.31 25.87 1.33 22.25 4.59 25.76"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2428.62 1380.34l-25.67 82.96-3.5 9.2-6.09 9.59"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2394.4 1483l8.29-10.76 34.22-91.9"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2390.95 1485.91s-38.71 105.64-40.09 109.59"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2049.05 1576.17l300.89 20.23"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2350.12 1596.57l3.12 3.33.14 9.86 3.94 107.04"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2503.79 1418.06s-1.26 37.82-4.7 69.34c-3.44 31.52-9.05 56.74-9.05 56.74"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2511.22 1129.93s2.37 28.7.84 63.72c-1.53 35.03-6.97 76.38-6.97 76.38"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2513.14 1191.49s6 .3 10.33 2.04c4.32 1.74 6.96 4.93 6.96 4.93"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2406.6 1121.53s-9.77 25.82-11.31 62.2c-1.54 36.38 5.16 83.33 5.16 83.33s-7 10.88-11.8 31.96c-4.79 21.08-7.37 52.36-7.37 52.36"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeDasharray="2, 2, 2"
          strokeWidth="1"
          d="M2294.35 1117.5s-8.11 13.3-11 24.92c-2.89 11.61-3.36 27.9-3.36 27.9"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="1"
          d="M2402.88 1265.37c-1.5-2.22 11.81-11.5 14.82-12.95 16.38-7.91 32.27-15.38 49.56-21.22 1.49-.5 15.07-2.33 16.07-.26"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="1"
          d="M2364.77 1261.47c-.43-.09 3.69-.27 4.4-.23 2.71.15 5.59.32 8.23.84 1.31.26 2.21 1.64 3.51 1.93 3.3.75 2.92-.77 5.71-.59 4.03.26 7.41 3.48 11.3 4.24"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
        <path
          strokeWidth="1"
          d="M2384.03 1361.38s7.21 2.12 13.77 2.24c6.57.11 8.09-1.19 8.09-1.19"
          opacity="0.971"
          fill="rgba(0,0,0,0)"
          className='object-glow'
        ></path>
      </g>
    </svg>
  );
}

export default GroupSexRoomRobertonOutline;